import React from "react";
import { useTranslation } from "react-i18next";
import { getAdminTabMetricColumns } from "../../config/adminTabMetricColumns";
import type { AdminHotelOverviewRow } from "../../types/adminOverview";
import { mapOverviewRowsToMetricRows } from "../../utils/mapOverviewRowToMetricRow";
import { AdminHotelsMetricTable } from "../shared/AdminHotelsMetricTable";

type AdminOverviewHotelsTableProps = {
  rows: AdminHotelOverviewRow[];
  loading: boolean;
};

export const AdminOverviewHotelsTable = ({
  rows,
  loading,
}: AdminOverviewHotelsTableProps): React.JSX.Element => {
  const { t } = useTranslation();

  const columns = React.useMemo(() => getAdminTabMetricColumns("overview"), []);
  const metricRows = React.useMemo(
    () => mapOverviewRowsToMetricRows(rows),
    [rows],
  );

  return (
    <AdminHotelsMetricTable
      tab="overview"
      columns={columns}
      rows={metricRows}
      loading={loading}
      emptyMessage={t(
        "analytics.admin.overview.table.empty",
        "No hotel overview data for the selected period.",
      )}
    />
  );
};
